import React from 'react'

const WarrantyTerms = () => {
    return (
        <div style={{ marginTop: "100px" }}>
            salam
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Rerum et maiores suscipit hic culpa temporibus placeat, impedit illo, facilis voluptatum veritatis dignissimos numquam debitis voluptates laboriosam doloribus amet at cumque consequatur deserunt quae vero harum ullam. Aliquam repellendus, perferendis adipisci quasi soluta tempore veritatis deserunt? Quis suscipit possimus veritatis esse corporis repellat repudiandae ea, voluptatem, fuga ipsum accusantium, quam officia natus obcaecati voluptates est modi. Ullam necessitatibus ab tempora eaque doloremque voluptatem distinctio voluptas similique cupiditate tempore ipsum facere architecto quas saepe excepturi in qui sequi, nihil maxime. Eius dignissimos quidem, in eligendi quas fugiat alias atque impedit ad quod?
        </div>
    )
}

export default WarrantyTerms
